var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgPieChartLine = function SvgPieChartLine(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 25 24"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M12.5 21a9 9 0 0 1-9-9 9 9 0 0 1 6.3-8.588v1.912A7.203 7.203 0 0 0 12.5 19.2a7.2 7.2 0 0 0 6.676-4.5h1.912A9 9 0 0 1 12.5 21m8.955-8.1H11.6V3.045a9 9 0 0 1 9.855 9.855M13.4 4.856V11.1h6.244A7.2 7.2 0 0 0 13.4 4.856"
  })));
};
export default SvgPieChartLine;